import { authGet } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";
import { DeploymentRepoListResponse } from "@types";

export const fetchDeploymentRepos = (
  deploymentId: string
): Promise<DeploymentRepoListResponse> => {
  let url = `${DEPLOYMENT_URL}/${deploymentId}/repos`;
  return authGet<DeploymentRepoListResponse>(url);
};
